import { createContext, useContext } from 'react';

type DeprecatedSidebarFormFactorContextValue = 'mobile' | 'desktop';

export const DeprecatedSidebarFormFactorContext =
  createContext<DeprecatedSidebarFormFactorContextValue>('desktop');

export const useDeprecatedSidebarFormFactor = () => useContext(DeprecatedSidebarFormFactorContext);
